var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo2Big(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 2C6.47685 2 2 6.47685 2 11.9995C2 17.5231 6.47685 22 12.0005 22C17.5221 22 22 17.5231 22 11.9995C22 6.47685 17.5221 2 12.0005 2ZM12.9338 5.61023C13.9088 5.61023 14.1952 6.17582 14.1952 6.82267C14.1952 7.62992 13.5494 8.37675 12.4463 8.37675C11.5235 8.37675 11.0839 7.91323 11.111 7.14557C11.111 6.49872 11.6516 5.61023 12.9338 5.61023ZM10.436 17.9888C9.76939 17.9888 9.28295 17.5836 9.74855 15.8076L10.5121 12.6567C10.6443 12.1526 10.6662 11.9505 10.5121 11.9505C10.3131 11.9505 9.44753 12.2984 8.93714 12.6422L8.60486 12.0974C10.2246 10.7443 12.087 9.95063 12.8838 9.95063C13.5504 9.95063 13.6609 10.7381 13.3286 11.9505L12.4536 15.2629C12.2984 15.8482 12.3651 16.0503 12.5203 16.0503C12.7203 16.0503 13.3744 15.8087 14.0181 15.3014L14.3952 15.8076C12.8192 17.3825 11.1016 17.9888 10.436 17.9888Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo2Big);
export default __webpack_public_path__ + "static/media/iconInfo2big.987431b0f013c49e7e40a96c7697b0b2.svg";
export { ForwardRef as ReactComponent };